import { render, staticRenderFns } from "./LoginCardForgotPassword.vue?vue&type=template&id=841875e6&scoped=true"
import script from "./LoginCardForgotPassword.vue?vue&type=script&lang=ts"
export * from "./LoginCardForgotPassword.vue?vue&type=script&lang=ts"
import style0 from "./LoginCardForgotPassword.vue?vue&type=style&index=0&id=841875e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841875e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
